import React, { useMemo } from "react";
import _map from "lodash/map";
import _groupBy from "lodash/groupBy";
import _flow from "lodash/flow";
import _toPairs from "lodash/toPairs";
import { IMappedSkills, useGetSkills } from "pages/Profile/hooks/useGetSkills";
import { commaJoin } from "shared-utils";

export const mapSkills = (data: IMappedSkills) => {
  return _map(data, ([categoryName, skills]) => {
    const groupedArray = _flow([
      (items) => _groupBy(items, (skill) => skill[2] || ""),
      _toPairs,
      (pairs) =>
        _map(pairs, ([level, skillsList]) => [
          level,
          _map(skillsList, (skill) => skill[0]),
        ]),
    ])(skills);

    return [categoryName, groupedArray];
  });
};

const SkillsPrint = () => {
  const { skills } = useGetSkills();

  const mappedSkills = useMemo(() => mapSkills(skills), [skills]);

  return (
    <div className="mt-6 space-y-4 pt-2">
      {mappedSkills.map(([category, skills]) => (
        <div className="grid grid-cols-[140px_1fr] gap-x-4" key={category}>
          <span className="font-bold">{category}:</span>
          <div className="flex flex-col space-y-1">
            {skills.map(([level, skillList], index) => (
              <span key={`${level}_${index}`}>
                {level && <strong className="mr-1">{level}:</strong>}
                {commaJoin(skillList)}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkillsPrint;
